import React from 'react';

import {Table, Button, Tag, message, Row, Col} from 'antd'
import {_getOptimizedRoute, _postCompleteLocationActionById} from '../../services';
import { API_ENDPOINT } from '../../index';
import moment from 'moment';


class OptimizedRoutesTable extends React.Component{

    constructor(props){
        super(props);
        this.state={
			route: [],
			idArray: [],
			selectedLocation: [],
			date: ""

        }
    }
		componentDidMount(){
			const routeId = this.props.routeId
			console.log(routeId)
			_getOptimizedRoute(routeId)
			.then(res=>{
				this.setState({
					route: res.data.optimizedLocations.slice(1,-1),
					date: res.data.date
				})
			})
		}

    render(){
		const rowSelection = {
			onChange: (selectedRowKeys, selectedRows) => {
			  this.setState({
				  selectedLocation: selectedRows
			  })
			},
			getCheckboxProps: record => ({
			  disabled: record.dateCompleted
			}),
		  };
		const columns = [
			
            {
                title: "Complete", 
				align:"center",
				key:"_id",
                render: (text, record) => (
					record.dateCompleted? <Tag color='green'>Completed</Tag> : <Tag color='red'>Not Completed</Tag>
                )   
            },
            {
                title: 'Invoice Number',
                dataIndex: 'invNum',
                key:'invNum'
			},
			{
                title: 'Company Name',
                dataIndex: 'address.companyName',
                key:'address.companyName'
			},
			{
                title: 'Supplier Address',
                dataIndex: 'address.address',
                key:'address.address'
			},
			{
                title: 'Postal Code',
                dataIndex: 'address.postalCode',
                key:'address.postalCode'
			},
			{
                title: 'Unit',
                dataIndex: 'address.unit',
                key:'address.unit'
			},
			{
                title: 'Contact',
                dataIndex: 'address.hp',
                key:'address.hp'
            },
            {
                title: 'Date Purchased',
				dataIndex: 'datePurchased',
				key: 'datePurchased',
                align:"center"
			},
			{
                title: 'Products',
				align:'center',
				key:'products[0].quantity',
                dataIndex:'products',
                render: (products) => (
                    products.map(_products=>
                        <Row key={_products.producttitle}>
                            {_products.productOrderId}
                            <Row type="flex" justify="space-around" align="middle" style={{width:'200px'}} key={_products.productTitle}>
                                <Col span={20} style={{marginBottom:'20px'}}>{_products.productTitle}</Col>
                                <Col span={2.5} style={{marginBottom:'20px'}}>{`x${_products.quantity}`}</Col>
                            </Row>
                        </Row>
                        
                    )
                ),
            },
            {
                title:"Tags", 
				align:"center",
				key:'locationActionRequired',
                dataIndex:"locationActionRequired",
                render:(locationActionRequired) => (
                    <span>
                        {<Tag color={locationActionRequired === "delivery" ? "blue" : "purple"} >{locationActionRequired}</Tag>}
                    </span>
                )
			},
			{
                title: 'Estimated Arrival Time',
                dataIndex: 'estimatedArrivalTime',
				key:'estimatedArrivalTime',
				render: (estimatedArrivalTime)=>(
					<div>
					{moment(estimatedArrivalTime).format("hh:mm a")}
					</div>
				)
            }
            
        ];
		return(
			<div>
				<Button
				style={{margin: '10px'}}
				type='primary'
				>
					<a href={`${API_ENDPOINT}/api/admin/delivery/routes/downloadCsv/${this.props.routeId}`} download={`${this.state.date}.csv`}>Download</a>
				</Button>
				<Button
				style={{margin: '10px'}}
				type='danger'
				onClick={this.completeSelectedLocations}
				>
					Complete Selected Locations
				</Button>
				<Table
					rowSelection={rowSelection}
					rowKey={record => record.deliveryLocationId}
					bordered
					dataSource={this.state.route}
					footer={() => ``}
					columns={columns}
					pagination = {false}
					style={{marginTop:'10px'}} 
				/>
			</div>	
    	)
	}

	completeSelectedLocations = () => {
		message.loading('completing...', 0)
		let locationIdArray = this.state.selectedLocation.map(_location=>_location.deliveryLocationId)
		let cartIdArray = this.state.selectedLocation.map(_location=>_location.cartId)
		_postCompleteLocationActionById(locationIdArray, this.props.routeId)
			.then(res=>{
				message.destroy()
				message.success(`Completed`)
				this.setState({
					route: res.data.optimizedLocations.slice(1,-1)
				})
			})
	}

	// download = (id) => {
	// 	_downloadOptimalRouteCsv(id)
	// 		.then(res=>{
	// 			const data = res.data
	// 			const downloadLink = document.createElement('a')
	// 			downloadLink.target = '_blank'
	// 			downloadLink.download = `optimizedRoute_${this.state.date}.csv`
	// 			const blob = new Blob([data], { type: 'text/csv' })
	// 			const URL = window.URL 
	// 			const downloadUrl = URL.createObjectURL(blob)
	// 			downloadLink.href = downloadUrl
	// 			downloadLink.click()
	// 			URL.revokeObjectURL(downloadUrl)
	// 		})
	// }
}   

export default OptimizedRoutesTable


// WEBPACK FOOTER //
// ./src/components/delivery-page/optimizedRouteTable.js